/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventsViewModel } from './EventsViewModel';
import {
    EventsViewModelFromJSON,
    EventsViewModelFromJSONTyped,
    EventsViewModelToJSON,
} from './EventsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfEventsViewModel
 */
export interface ResultOfEventsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfEventsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfEventsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfEventsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfEventsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfEventsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfEventsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfEventsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {EventsViewModel}
     * @memberof ResultOfEventsViewModel
     */
    data?: EventsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfEventsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfEventsViewModel interface.
 */
export function instanceOfResultOfEventsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfEventsViewModelFromJSON(json: any): ResultOfEventsViewModel {
    return ResultOfEventsViewModelFromJSONTyped(json, false);
}

export function ResultOfEventsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfEventsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : EventsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfEventsViewModelToJSON(value?: ResultOfEventsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': EventsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

